//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BuildingBanner from '../_components/_building_banner'
export default {
    components: {
        BuildingBanner
    },
    props: {
        items: Array,
        type: String,
        building_id: [Number, String]
    },
    computed: {
        title () {
            return this.type === 'layout_detail' ? '该楼盘其他户型图' : '户型图'
        },
        more_text () {
            return this.type === 'layout_detail' ? '全部' : '查看更多'
        }
    },
    methods: {
        sendLog(){
            this.$sendCtmEvtLog('楼盘详情-功能模块-户型图点击', {building_id: this.building_id})
        },
        tapItem (item) {
            if (item.audio_url || item.vr_url || item.video_url) {
                this.$emit('openDetail', item.id)
            } else {
                this.$wx.previewImage({
                    current: item.orginal_url,
                    urls: this.items.map(({ orginal_url }) => orginal_url)
                })
            }
        }
    }
}
